import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "../src/utils/authConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

// MSAL v3+ requires explicit initialize() before any other API calls.
// In MSAL v2 this happened automatically, hence the regression after upgrade.
msalInstance
  .initialize()
  .then(() => {
    console.log("MSAL initialized");

    // Restore active account from previous session if available
    const existingAccounts = msalInstance.getAllAccounts();
    if (existingAccounts.length > 0) {
      msalInstance.setActiveAccount(existingAccounts[0]);
    }

    // Set active account after a successful login redirect completes
    msalInstance.addEventCallback((event) => {
      if (
        (event.eventType === EventType.LOGIN_SUCCESS ||
          event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) &&
        event.payload &&
        event.payload.account
      ) {
        msalInstance.setActiveAccount(event.payload.account);
      }
    });

    // MSAL v3+ requires explicit handleRedirectPromise call to process the
    // authorization code returned from Azure AD after loginRedirect.
    return msalInstance.handleRedirectPromise();
  })
  .then((response) => {
    if (response && response.account) {
      msalInstance.setActiveAccount(response.account);
    }

    const root = ReactDOM.createRoot(document.getElementById("root"));
    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </React.StrictMode>
    );

    reportWebVitals();
  })
  .catch((error) => {
    console.error("MSAL initialization or redirect handling failed:", error);
  });
